import { AppThunk } from 'store/rootStore';

import { addText } from '../actions';
import { checkIfTextLimitIsAchievedThunk } from './checkIfTextLimitIsAchieved';

export const addTextThunk = (): AppThunk<void> => async dispatch => {
  dispatch(addText());
  dispatch(checkIfTextLimitIsAchievedThunk());
};
